'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var links = require('./links'),
    ids = require('./ids'),

    toSave = {},
    wiFiVisited = false,
    gettext, renders;


/**
 * Open LAN.
 *
 * @param {Function} openCallback - result handler
 *
 * @this list
 */
function openLan ( openCallback ) {
    var self = this,
        getter = links.api.getters.environment,
        saver = links.api.savers.environment,
        index, list, authOptions,
        auth, encryptionOptions, encryption;

    switch ( this.value.auth ) {
        case 'WPA2':
            auth = 'wpa2psk';
            break;
        case 'WPAAUTO':
            auth = 'wep_auto';
            break;
        case 'WPA':
            auth = 'wpapsk';
            break;
        default:
            auth = 'open';
            break;
    }
    toSave['wifi_auth'] = auth;

    switch ( this.value.enc ) {
        case 'TKIP':
            encryption = 'tkip';
            break;
        case 'WEP':
            encryption = 'wep';
            break;
        case 'CCMP':
            encryption = 'aes';
            break;
        default:
            encryption = 'none';
            break;
    }
    toSave['wifi_enc'] = encryption;

    authOptions = [
        {name: gettext('Open'), value: 'open'},
        {name: gettext('Shared key'), value: 'shared'},
        {name: gettext('Auto Open/Shared key'), value: 'wep_auto'},
        {name: 'WPA PSK', value: 'wpapsk'},
        {name: 'WPA2 PSK', value: 'wpa2psk'}
    ];

    for ( index = 0; index < authOptions.length; index++ ) {
        if ( authOptions[index].value === auth ) {
            authOptions[index].selected = true;
            break;
        }
    }

    encryptionOptions = [
        {name: gettext('NONE'), value: 'none'},
        {name: 'WEP', value: 'wep'},
        {name: 'TKIP', value: 'tkip'},
        {name: 'AES', value: 'aes'}
    ];

    for ( index = 0; index < encryptionOptions.length; index++ ) {
        if ( encryptionOptions[index].value === encryption ) {
            encryptionOptions[index].selected = true;
            break;
        }
    }

    toSave['wifi_ssid'] = this.value.ssid;

    //TODO check value
    switch ( core.device.model ) {
        case 'emulator':
        case 'AndroidAPP':
            list = [
                {
                    id: ids.wifiAddElement + self.value.ssid + 1,
                    name: gettext('SSID'),
                    description: '',
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter SSID'),
                        value: self.value.ssid || '',
                        mode: 'qwerty'
                    },
                    saveImmediate: false,
                    environment: {
                        'wifi_ssid': ''
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = self.value.ssid || data['wifi_ssid'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_ssid'] = value;
                        self.value.ssid = value;
                        delete toSave['wifi_ssid'];
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 2,
                    name: gettext('Authentication mode'),
                    description: '',
                    icon: 'theme-icon-network',
                    render: renders.popupSelect,
                    title: gettext('Select authentication mode'),
                    saveImmediate: false,
                    advanced: !!self.value.id,
                    environment: {
                        'wifi_auth': ''
                    },
                    prepareForRender: function ( environment, callback ) {
                        callback(authOptions);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_auth'] = value;
                        delete toSave['wifi_auth'];
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 3,
                    name: gettext('Encryption'),
                    description: '',
                    icon: 'theme-icon-network',
                    render: renders.popupSelect,
                    title: gettext('Select encryption'),
                    mode: 'qwerty',
                    saveImmediate: false,
                    advanced: !!self.value.id,
                    environment: {
                        'wifi_enc': ''
                    },
                    prepareForRender: function ( environment, callback ) {
                        callback(encryptionOptions);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_enc'] = value;
                        delete toSave['wifi_enc'];
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 4,
                    name: gettext('Password'),
                    description: '',
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter password'),
                        mode: 'qwerty',
                        type: 'password'
                    },
                    saveImmediate: false,
                    environment: {
                        'wifi_psk': ''
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = data['wifi_psk'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_psk'] = value;
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                }
            ];
            break;
        default:
            list = [
                {
                    id: ids.wifiAddElement + self.value.ssid + 1,
                    name: gettext('SSID'),
                    description: '',
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter SSID'),
                        value: self.value.ssid || '',
                        mode: 'qwerty'
                    },
                    saveImmediate: false,
                    environment: {
                        'wifi_ssid': ''
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = self.value.ssid || data['wifi_ssid'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_ssid'] = value;
                        self.value.ssid = value;
                        delete toSave['wifi_ssid'];
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 2,
                    name: gettext('Authentication mode'),
                    description: '',
                    icon: 'theme-icon-network',
                    render: renders.popupSelect,
                    title: gettext('Select authentication mode'),
                    saveImmediate: false,
                    advanced: !!self.value.id,
                    environment: {
                        'wifi_auth': ''
                    },
                    prepareForRender: function ( environment, callback ) {
                        callback(authOptions);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_auth'] = value;
                        delete toSave['wifi_auth'];
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 3,
                    name: gettext('Encryption'),
                    description: '',
                    icon: 'theme-icon-network',
                    render: renders.popupSelect,
                    title: gettext('Select encryption'),
                    mode: 'qwerty',
                    saveImmediate: false,
                    advanced: !!self.value.id,
                    environment: {
                        'wifi_enc': ''
                    },
                    prepareForRender: function ( environment, callback ) {
                        callback(encryptionOptions);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_enc'] = value;
                        delete toSave['wifi_enc'];
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 4,
                    name: gettext('Password'),
                    description: '',
                    icon: '',
                    render: renders.input,
                    config: {
                        title: gettext('Enter password'),
                        mode: 'qwerty',
                        type: 'password'
                    },
                    saveImmediate: false,
                    environment: {
                        'wifi_psk': ''
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = data['wifi_psk'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_psk'] = value;
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 5,
                    name: gettext('IP'),
                    description: '',
                    icon: '',
                    render: renders.input,
                    advanced: true,
                    config: {
                        title: gettext('Enter ip'),
                        mode: 'number'
                    },
                    saveImmediate: false,
                    environment: {
                        'wifi_int_ip': '0.0.0.0'
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = data['wifi_int_ip'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_int_ip'] = value;
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 6,
                    name: gettext('Network mask'),
                    description: '',
                    icon: 'theme-icon-network',
                    render: renders.input,
                    config: {
                        title: gettext('Enter network mask'),
                        mode: 'number'
                    },
                    saveImmediate: false,
                    advanced: true,
                    environment: {
                        'wifi_int_mask': '0.0.0.0'
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = data['wifi_int_mask'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_int_mask'] = value;
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 7,
                    name: gettext('Gateway'),
                    description: '',
                    icon: 'theme-icon-network',
                    render: renders.input,
                    config: {
                        title: gettext('Enter gateway'),
                        type: 'text',
                        mode: 'number'
                    },
                    saveImmediate: false,
                    advanced: true,
                    environment: {
                        'wifi_int_gw': '0.0.0.0'
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = data['wifi_int_gw'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_int_gw'] = value;
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                },
                {
                    id: ids.wifiAddElement + self.value.ssid + 8,
                    name: gettext('DNS'),
                    description: '',
                    icon: '',
                    render: renders.input,
                    saveImmediate: false,
                    advanced: true,
                    config: {
                        title: gettext('Enter DNS'),
                        type: 'text',
                        mode: 'qwerty'
                    },
                    environment: {
                        'wifi_int_dns': '0.0.0.0'
                    },
                    prepareForRender: function ( data, callback ) {
                        this.config.value = data['wifi_int_dns'];
                        callback(this.config.value);
                    },
                    prepareForSave: function ( value, callback ) {
                        this.environment['wifi_int_dns'] = value;
                        callback();
                    },
                    getter: getter,
                    saver: saver,
                    type: 'option',
                    parent: self.id
                }

            ];
            break;
    }

    openCallback(null, list);
}


function save () {
    gSTB.SetEnv(JSON.stringify(toSave));
    gSTB.ServiceControl('wifi', 'restart');
}


function addWifi ( addCallback ) {
    var environmentData = JSON.parse(gSTB.GetEnv('{"varList":["wifi_ssid", "wifi_off"]}')),
        getter = links.api.getters.environment,
        saver = links.api.savers.environment,
        result, index, item,
        frequency, channel,
        auth, encryption, list,
        wifiOff;

    wifiOff = environmentData.result.wifi_off === '1';

    if ( gSTB.GetNetworkWifiMac() === '' && !wiFiVisited ) {
        if ( addCallback ) {
            addCallback(gettext('Wi-Fi adapter not connected'));
        }

        return;
    }

    list = [
        {
            id: ids.wifiEnable,
            name: gettext('Enable'),
            description: '',
            icon: '',
            render: renders.toggle,
            saveImmediate: true,
            environment: {
                // "wifi_off": false
            },
            prepareForRender: function ( data, callback ) {
                callback(!wifiOff);
            },
            prepareForSave: function ( value, callback ) {
                // this.environment['wifi_off'] = value;
                wifiOff = value;
                // console.log(JSON.stringify(links.api.actions));
                // links.api.actions.view.refresh();
                gSTB.SetEnv('{"wifi_off": ' + (value ? 0 : 1) + '}');
                gSTB.ServiceControl('wifi', 'restart');
                callback();
                addWifi();

            },
            type: 'option',
            getter: getter,
            saver: saver,
            parent: ids.wifi
        }
    ];

    if ( wifiOff ) {
        if ( addCallback ) {
            addCallback(null, list);
        } else {
            links.api.actions.view.init({
                data: list
            });
        }

        return;
    }

    result = JSON.parse(gSTB.GetWifiGroups()).result;

    for ( index = 0; index < result.length; index++ ) {
        item = result[index];

        auth = item.auth.toLowerCase();
        encryption = item.enc.toLowerCase();
        if ( (auth === 'none' && encryption === 'none') || (auth === 'open' && encryption === 'none') ) {
            item.unlock = true;
        } else {
            item.unlock = false;
        }
        if ( item.ssid === environmentData.result.wifi_ssid ) {
            item.connected = true;
        }
        frequency = item.rfInfo.substring((item.rfInfo.indexOf(':') + 1), item.rfInfo.indexOf('('));
        channel = item.rfInfo.substring((item.rfInfo.indexOf('l') + 1), item.rfInfo.indexOf(')'));

        list.push({
            id: ids.wifiList + index,
            name: item.ssid,
            value: item,
            description: [
                {
                    label: gettext('Authentication mode') + ':',
                    value: item.auth
                },
                {
                    label: gettext('Encryption') + ':',
                    value: item.enc
                },
                {
                    label: gettext('Frequency') + ':',
                    value: frequency.trim()
                },
                {
                    label: gettext('Channel') + ':',
                    value: channel.trim()
                },
                {
                    label: gettext('Signal info') + ':',
                    value: item.signalInfo + ' dB'
                }
            ],
            icon: 'theme-icon-network',
            type: 'section',
            parent: ids.wifi,
            onenter: openLan,
            onsave: save
        });
    }

    list.push({
        id: ids.wifiAdd,
        name: gettext('Add network'),
        description: gettext('Adding hidden Wifi networks'),
        icon: 'theme-icon-plus',
        type: 'section',
        parent: ids.wifi,
        value: {},
        onenter: openLan
    });

    if ( addCallback ) {
        addCallback(null, list);
    } else {
        links.api.actions.view.init({
            data: list
        });
    }
}


module.exports = function ( data ) {
    renders = links.api.renders;
    gettext = links.gettext;

    data.sections.push({
        id: ids.wifi,
        name: gettext('Wireless (Wi-Fi)'),
        description: gettext('Setting up wireless access to the Internet or a local area network'),
        icon: 'theme-icon-wifi',
        parent: ids.base,
        onenter: addWifi
    });
};
